import { render, staticRenderFns } from "./Sortiment.vue?vue&type=template&id=726f011f&scoped=true"
import script from "./Sortiment.vue?vue&type=script&lang=js"
export * from "./Sortiment.vue?vue&type=script&lang=js"
import style0 from "./Sortiment.vue?vue&type=style&index=0&id=726f011f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f011f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726f011f')) {
      api.createRecord('726f011f', component.options)
    } else {
      api.reload('726f011f', component.options)
    }
    module.hot.accept("./Sortiment.vue?vue&type=template&id=726f011f&scoped=true", function () {
      api.rerender('726f011f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Sortiment.vue"
export default component.exports